// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"61cd693a","8119":"b6a20ffa","8912":"b6a20ffa","9346":"21038a89"}[chunkId] + ".chunk.css";
};